module.exports = __webpack_public_path__ + "assets/img/sabc_tv_schedule_sport_sabc_unselect.svg?67e6be60595044b89433b4094adca70c";